<div [ngClass]="{'form-container': showBorder, 'wide': wide}">
  @if (title) {
    <h3 class="form-title" [ngStyle]="{'font-size': titleSize + 'px'}">{{ title }}</h3>
  }
  <div class="d-flex flex-column gap-3">
    <ng-content select="[form-content]"></ng-content>
  </div>
  <div class="d-flex flex-wrap gap-2 mt-4 w-100">
    <ng-content select="[form-actions]"></ng-content>
  </div>
</div>
